export const getStatusSeverity = (status) => {
  const statusMap = {
    uploaded: "#fde68a",
    failed: "#fca5a5",
    processing: "#7dd3fc",
    processed: "#d8b4fe",
    verified: "#b7d5d4",
    completed: "#86efac",
    flagged: "#fccd9a"
  }
  return statusMap[status] || "#f3f3f3"
}

export const getStatusTextColor = () => {
  return "#000000"
}

export const capitalizeStatus = (status) => {
  if (!status) return ""
  return status.charAt(0).toUpperCase() + status.slice(1)
}
